import React, { Component } from 'react';
import {
  CircularProgress, Typography, TextField, Button, Container, Grid
} from '@material-ui/core';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';

// Redux
import { connect } from 'react-redux';
import { resetPassword } from '../../../redux/actions/authActions';
import { setAlert, setSuccess } from '../../../redux/actions/alertActions';

// Constants
import { DEFAULT, GREY } from '../../../constants';

class ResetPassword extends Component {

  constructor(props) {
    super(props);

    this.state = {
      newPassword: '',
      confirmNewPassword: '',
      succeeded: false
    };
  }

  onChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };

  getToken = () => new URLSearchParams(this.props.location.search).get('token');

  onSubmit = (e) => {
    e.preventDefault();

    const token = this.getToken();

    if (!token) {
      this.props.setError('This reset link is missing its token. Please request a new one.');
    }
    else if (this.state.newPassword === '' || this.state.confirmNewPassword === '') {
      this.props.setError('Error: You cannot leave a field blank.');
    }
    else if (this.state.newPassword !== this.state.confirmNewPassword) {
      this.props.setError('Error: Passwords must match.');
    }
    else {
      this.props.handleResetPassword(token, this.state.newPassword).then((succeeded) => {
        if (succeeded) {
          this.setState({ succeeded: true });
          this.props.setSuccess('Successfully reset your password! You can now log in.');
        }
      });
    }
  }

  render() {
    return (
      <Container style={{ marginTop: '10%' }}>
        <h1
          style={{ color: GREY.dark, textAlign: 'center', marginTop: '1em', marginBottom: '1em' }}
        >
          Reset Password
        </h1>

        {this.state.succeeded ? (
          <Container style={{ textAlign: 'center' }}>
            <p>
              Your password has been reset. <a href='/auth/login'>Click here</a> to log in.
            </p>
          </Container>
        ) : (
          <form autoComplete='off' onSubmit={this.onSubmit}>
            <Grid container spacing={4}>
              <Grid item xs={12}>
                <Typography variant='h6' style={{ width: '100%', marginBottom: '15px', marginTop: '25px' }}>Choose a new password. Passwords are required to have all of the following: uppercase letter, lowercase letter, symbol, and number.</Typography>
              </Grid>
              <Grid item xs={12}>
                <TextField required type="password" name="newPassword" label="New Password" style={{ width: '100%', marginBottom: '5px' }} onChange={this.onChange} variant='filled' />
              </Grid>
              <Grid item xs={12}>
                <TextField required type="password" name="confirmNewPassword" label="Confirm New Password" style={{ width: '100%', marginBottom: '5px' }} onChange={this.onChange} variant='filled' />
              </Grid>
              {/* Submit Button */}
              <Grid item xs={12} style={{ display: 'flex', justifyContent: 'center', marginBottom: '2em' }}>
                <Button type='submit' variant="contained" style={{ width: '200px', backgroundColor: this.props.statusColor.main, color: this.props.statusColor.text }} disabled={this.props.isLoading}>
                  Submit
                  {this.props.isLoading && <CircularProgress size={25} style={{ color: this.props.statusColor.text, marginLeft: '1em' }} />}
                </Button>
              </Grid>
            </Grid>
          </form>
        )}
      </Container>

    );
  }
}

const mapStateToProps = state => ({
  statusColor: state.status.schoolStatus ? state.status.schoolStatus.getColor() : DEFAULT,
  isLoading: state.auth.isLoading
});

const mapDispatchToProps = dispatch => ({
  setError: (msg) => setAlert(dispatch, msg),
  setSuccess: (msg) => setSuccess(dispatch, msg),
  handleResetPassword: (token, password) => resetPassword(dispatch, token, password)
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(ResetPassword));

ResetPassword.propTypes = {
  setError: PropTypes.func,
  setSuccess: PropTypes.func,
  handleResetPassword: PropTypes.func,
  statusColor: PropTypes.object,
  isLoading: PropTypes.bool,
  location: PropTypes.object
};
